// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, LitElement, nothing } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property } from 'lit/decorators.js';
import LightElement from './light-element.js';

@customElement('number-formatter')
export default class NumberFormatter extends LightElement {

	@property({ type: Number })
	value: number;

	private formatNumber(value) {
		let number = value;

		// Round to 2 decimal places
		number = number.toFixed(2);

		// Remove .00 if present
		if (number.endsWith('.00')) {
			number = number.slice(0, -3);
		}

		return number;
	}

	render() {
		const formattedNumber = this.formatNumber(this.value);
		return html`<span>${formattedNumber}</span>`;
	}

}
